import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/shared/api/client'
import type {
  TeaCategory,
  TeaSubcategory,
  TeawareCategory,
  TeawareSubcategory,
} from '../model/types'

// Re-export types for convenience
export type { TeaCategory, TeaSubcategory, TeawareCategory, TeawareSubcategory }

/**
 * Ответ API для категорий
 */
export interface CategoriesResponse<T> {
  data: T[]
}

/**
 * Хук для получения категорий чая
 * 
 * @returns Query результат с данными категорий чая
 * 
 * @example
 * ```tsx
 * const { data, isLoading } = useTeaCategories()
 * const categories = data?.data || []
 * ```
 */
export function useTeaCategories() {
  return useQuery({
    queryKey: ['tea-categories'],
    queryFn: async () => {
      return apiClient<CategoriesResponse<TeaCategory>>('/api/public/tea/categories')
    },
    staleTime: 5 * 60 * 1000, // 5 минут
  })
}

/**
 * Хук для получения категорий посуды
 * 
 * @returns Query результат с данными категорий посуды
 * 
 * @example
 * ```tsx
 * const { data, isLoading } = useTeawareCategories()
 * const categories = data?.data || []
 * ```
 */
export function useTeawareCategories() {
  return useQuery({
    queryKey: ['teaware-categories'],
    queryFn: async () => {
      return apiClient<CategoriesResponse<TeawareCategory>>('/api/public/teaware/categories')
    },
    staleTime: 5 * 60 * 1000, // 5 минут
  })
}

